var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugcareBubbleMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 15,
    viewBox: "0 0 31 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2841 15C4.88872 15 0.609648 5 0.144531 0H30.1445C17.8655 0 17.1213 10 18.2841 15Z",
    fill: "#BFE3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugcareBubbleMint);
export default __webpack_public_path__ + "static/media/hugcare-bubble_mint.2f0fc88b4e7ae652fc8399358a0c2d6d.svg";
export { ForwardRef as ReactComponent };